const EXCLUDED_VARIATION_NAME = "Excluded";
const isExcludedVariation = (variation) => variation.name === EXCLUDED_VARIATION_NAME && variation.id === null;
export { isExcludedVariation };
